import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import DailyHub from "./components/DailyHub";
import CategorySection from "./components/CategorySection";
import Ranking from "./components/Ranking";
import Faq from "./components/Faq";
import CtaSubscribe from "./components/CtaSubscribe";
import Footer from "./components/Footer";
import { categories, articles } from "@/mocks/contest";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-900 text-background-50 shadow-lg transition hover:bg-primary-600 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 font-sans text-foreground-900">
      <Header />
      <Hero />
      <DailyHub />

      {categories.map((cat, i) => (
        <CategorySection
          key={cat.key}
          category={cat}
          articles={articles.filter((a) => a.category === cat.key)}
          index={i}
        />
      ))}

      <Ranking />
      <Faq />
      <CtaSubscribe />
      <Footer />
      <BackToTop />
    </main>
  );
}